import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://puw7hcocfk.execute-api.us-east-1.amazonaws.com/dev',

  // ⚠️ MODO DESARROLLO: Cambiar a true para bypasear autenticación
  // ⚠️ IMPORTANTE: Asegúrate de que sea false antes de hacer push
  useMockAuth: false,

  // Usuario mock para desarrollo local
  mockUser: {
    username: 'dev@lala.com',
    email: 'dev@lala.com',
    name: 'Developer Local',
    sub: 'mock-user-id-12345',
    exp: Math.floor(Date.now() / 1000) + 24 * 60 * 60, // Expira en 24 horas
  },

  // Configuración de autenticación
  useAzureAd: true, // Cambiar a true para usar Azure AD, false para Cognito

  // Configuración de AWS Amplify (Cognito) - para compatibilidad
  cognito: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_kpv4gMMX4',
    userPoolWebClientId: '3v1n3tvh5r6p3quv5ejgs9e19n',
    signUpVerificationMethod: 'code',
    oauth: {
      domain: 'http://localhost:4200/',
      redirectSignIn: 'http://localhost:4200/upload',
      redirectSignOut: 'http://localhost:4200/login',
      responseType: 'code',
    },
  },

  // Configuración de Azure AD
  azureAd: {
    clientId: 'c59f692a-b09b-4bd1-9c01-3453ee57da4a',
    tenantId: '6bc21fa9-e5b8-4501-93db-ac165a1c1e6c',
    authority:
      'https://login.microsoftonline.com/6bc21fa9-e5b8-4501-93db-ac165a1c1e6c',
    redirectUri: 'https://d2w9dyaz36fw1n.cloudfront.net/login',
    postLogoutRedirectUri: 'https://d2w9dyaz36fw1n.cloudfront.net/login',
    scopes: ['openid', 'profile', 'email', 'User.Read'],
    usePopup: true, // true para usar popup (se queda en la misma página)
  },
};
